var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"bg-variant":_vm.bgColor,"body-bg-variant":_vm.bodyBgColor,"header":_vm.header,"no-body":_vm.noBody,"title":_vm.title},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }